module.exports = __webpack_public_path__ + "img/movie-title.1b7b0ccd.png";